import React, { useState, useEffect } from 'react';
import { StoriesFilter } from './components/StoriesFilter';
import { StoriesList } from './components/StoriesList';
import './Stories.scss';
import { getFiltersFromURL } from './Stories.helpers';
import { useLoadMoreStories } from './Stories.hooks';
import {
  StoriesFilter as StoriesFilterType,
  StoriesList as StoriesListType,
} from './Stories.types';
import { useFetchStoriesPageDataQuery, useLazyFetchStoriesQuery } from './Stories.service';
import { LoadingSpinner } from '@components/LoadingSpinner';

const StoriesPage = () => {
  const [storiesList, setStoriesList] = useState<StoriesListType>({
    StoriesListItems: [],
    HasNextPage: true,
  });

  const [page, setPage] = useState(1);
  const { data: storiesPage, isLoading: isLoadingPage } = useFetchStoriesPageDataQuery();
  const [doFetchStories, { data: stories, isFetching: isLoadingStories, isUninitialized }] =
    useLazyFetchStoriesQuery();

  useLoadMoreStories({
    hasNextPage: stories?.HasNextPage,
    isLoadingStories,
    onLoadMoreStories: () => {
      const nextPage = page + 1;
      setPage(nextPage);
    },
  });

  const onSaveFilters = (filters: Omit<StoriesFilterType, 'page'>) => {
    setPage(1);
    doFetchStories({ ...filters, page: 1 }).then(({ data }) => setStoriesList(data));
  };

  useEffect(() => {
    const filters = getFiltersFromURL();

    if (!isUninitialized && page === 1) return;
    // appending new items to the list
    doFetchStories({ ...filters, page }).then(({ data }) => {
      setStoriesList((storiesList) => ({
        HasNextPage: data?.HasNextPage,
        StoriesListItems: [...storiesList.StoriesListItems, ...data?.StoriesListItems],
      }));
    });
  }, [page]);

  if (isLoadingPage) {
    return <LoadingSpinner />;
  }
  return (
    <>
      <h1>{storiesPage.I18n.PageTitle}</h1>
      <StoriesFilter
        i18n={storiesPage.I18n}
        storiesPageData={storiesPage}
        onStoriesUpdate={onSaveFilters}
      />

      <StoriesList
        isLoading={isLoadingStories}
        isUninitialized={isUninitialized}
        list={storiesList?.StoriesListItems || []}
        i18n={storiesPage.I18n}
      />
    </>
  );
};

export default StoriesPage;
